"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ApplyReval = void 0;
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var ApplyReval;
exports.ApplyReval = ApplyReval;
(function (ApplyReval) {
  var Changes = /*#__PURE__*/function () {
    function Changes(catalog, modelFrom, modelTo, ruleFrom, ruleTo) {
      (0, _classCallCheck2["default"])(this, Changes);
      this.catalog = null;
      this.modelFrom = null;
      this.modelTo = null;
      this.ruleFrom = null;
      this.ruleTo = null;
      this.items = [];
      this.vars = [];
      this.applyToSelected = false;
      this.catalog = catalog;
      this.modelFrom = modelFrom;
      this.modelTo = modelTo;
      this.ruleFrom = ruleFrom;
      this.ruleTo = ruleTo;
    }
    (0, _createClass2["default"])(Changes, [{
      key: "pushItem",
      value: function pushItem(row) {
        this.items.push(row);
      }
    }, {
      key: "pushVar",
      value: function pushVar(variant) {
        this.vars.push(variant);
      }
    }, {
      key: "getRevalData",
      value: function getRevalData() {
        return {
          catalog: this.catalog,
          vars: this.vars,
          modelfrom: this.modelFrom && this.modelFrom.cmodel ? this.modelFrom.cmodel : null,
          modelto: this.modelTo && this.modelTo.cmodel ? this.modelTo.cmodel : null
        };
      }
    }], [{
      key: "getChanges",
      value: function getChanges(catalog, modelFrom, modelTo, ruleFrom, ruleTo, enabledVariants) {
        var changes = new Changes(catalog, modelFrom, modelTo, ruleFrom, ruleTo);
        var rowsTo = ruleTo.rows;
        (0, _forEach["default"])(rowsTo).call(rowsTo, function (x) {
          if (enabledVariants && (0, _keys["default"])(enabledVariants).length !== 0) {
            if (!enabledVariants[x.cod]) return;
          }
          if (ruleFrom) {
            var rowsFrom = ruleFrom.rows;
            var rowByCod = (0, _find["default"])(rowsFrom).call(rowsFrom, function (r) {
              return r.cod === x.cod;
            });
            if (x.value !== rowByCod.value) {
              changes.pushVar(new VariantChange(x.cod, '*', x.value));
            }
          } else {
            changes.pushVar(new VariantChange(x.cod, '*', x.value));
          }
        });
        return changes;
      }
    }]);
    return Changes;
  }();
  ApplyReval.Changes = Changes;
  var VariantChange = /*#__PURE__*/(0, _createClass2["default"])(function VariantChange(code, fromValue, toValue) {
    (0, _classCallCheck2["default"])(this, VariantChange);
    this.name = null;
    this.from = null;
    this.to = null;
    this.name = code;
    this.from = fromValue;
    this.to = toValue;
  });
  ApplyReval.VariantChange = VariantChange;
})(ApplyReval || (exports.ApplyReval = ApplyReval = {}));
//# sourceMappingURL=ApplyReval.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/controllers/ApplyReval.js
// module id = 1239
// module chunks = 142